"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import _ from "underscore";
import PartialFetcher from "./partial_fetcher";
import DocumentGroupStore from "../stores/document_group_store";
import ObjectWithIDStore from "../stores/object_with_id_store";
import DataStoreService from "./data_store_service";
import fetch from "../util/fetch";
import Account from "../api/account";
const DocumentsService = function() {
  this.documents = {};
  this.documentBatches = new ObjectWithIDStore();
  this.documentsByLoadId = {};
  const self = this;
  this.types = [
    { name: "Bill of Lading", value: "billOfLading", pos: 3 },
    { name: "Factoring Assignment", value: "factoringAssignment", pos: 0 },
    { name: "Invoice", value: "invoice", pos: 1 },
    { name: "Other", value: "other", pos: 7 },
    { name: "Packing Slip", value: "packingSlip", pos: 6 },
    { name: "Delivery Receipt", value: "proofOfDelivery", pos: 4 },
    { name: "Rate Confirmation", value: "loadTender", pos: 2 },
    { name: "Weight Ticket / Gate Pass", value: "weightTicket", pos: 5 }
  ];
  this.typesMap = {};
  this.types.forEach((type) => {
    self.typesMap[type.value] = type;
  });
  const documentsFromIds = (ids) => {
    return _.compact(ids.map((id) => this.documents[id]));
  };
  const fetchMissingDocuments = (ids, docs) => {
    const toFetch = _.difference(ids, _.pluck(docs, "id"));
    return fetch("/api/documents/multiple?ids=" + toFetch.join(",")).then(
      (data) => {
        data.documents.forEach((doc) => self.documents[doc.id] = doc);
        return documentsFromIds(ids);
      }
    );
  };
  const fetchDocumentBatch = (id) => (
    // Only check duplicates for payments network accounts
    Account.paymentsNetworkEnabled() ? Promise.all([
      fetch("/api/imports/document_batches/" + id),
      fetch(
        "/api/document_batches/" + id + "/approved_carrier_invoice_duplicate"
      ).then(
        (dupe) => dupe.carrier_invoice && dupe.carrier_invoice.id ? dupe : {
          carrier_invoice: void 0,
          carrier_invoice_submission: void 0
        }
      ).catch(() => ({
        carrier_invoice: void 0,
        carrier_invoice_submission: void 0
      }))
    ]).then(
      ([
        batchData,
        {
          // @ts-expect-error
          carrier_invoice: duplicateInvoice,
          // @ts-expect-error
          carrier_invoice_submission: carrierInvoiceSubmission
        }
      ]) => {
        const batch = self.updateDocumentBatch(__spreadProps(__spreadValues({}, batchData.document_batch), {
          duplicateInvoice,
          carrierInvoiceSubmission
        }));
        DataStoreService.updateStores(_.omit(batchData, "document_batch"));
        return batch;
      }
    ) : fetch(
      "/api/imports/document_batches/" + id
    ).then((data) => {
      const batch = self.updateDocumentBatch(data.document_batch);
      DataStoreService.updateStores(_.omit(data, "document_batch"));
      return batch;
    })
  );
  this.getDocumentById = function(id) {
    return self.documents[id];
  };
  this.getDocuments = function(ids = []) {
    const docs = documentsFromIds(ids);
    if (docs.length === ids.length) {
      return Promise.resolve(docs);
    }
    return fetchMissingDocuments(ids, docs);
  };
  this.documentBatchFetcher = new PartialFetcher(
    this.documentBatches,
    (ids) => {
      return fetch("/api/imports/document_batches/bulk", {
        data: { ids }
      }).then((data) => data.document_batches);
    }
  );
  this.getDocumentBatches = function(ids, validator) {
    return this.documentBatchFetcher.fetchItemsIfNeeded(ids, validator);
  };
  this.getDocumentBatch = function(id) {
    return this.documentBatchFetcher.fetchItemIfNeeded(id);
  };
  this.getFetchedDocumentBatch = function(id) {
    return this.documentBatches.find(id);
  };
  this.getUncachedDocumentBatch = function(id) {
    return fetchDocumentBatch(id);
  };
  this.updateDocumentBatch = function(batch) {
    if (batch.documents) {
      self.updateDocuments(batch.documents);
      batch.documents = _.compact(
        batch.documents.map((document) => {
          return self.documents[document.id];
        })
      );
    }
    batch.document_groups = DocumentGroupStore.addOrUpdateAll(
      batch.document_groups
    );
    return self.documentBatches.addOrUpdate(batch);
  };
  this.updateDocuments = function(documents) {
    documents.forEach((document) => {
      const existing = self.documents[document.id];
      if (existing) {
        _.extend(existing, document);
        if (document.deleted_at) {
          delete self.documents[document.id];
        }
      } else {
        self.documents[document.id] = document;
      }
    });
  };
  this.replaceDocumentPage = (page) => {
    const doc = self.documents[page.document_id];
    const findKey = page.parent_id || page.id;
    if (doc && findKey) {
      const pageToReplace = doc.pages.filter(
        (p) => p.parent_id === findKey || p.id === findKey
      )[0];
      return Object.assign(pageToReplace, page);
    }
  };
};
const documentsService = new DocumentsService();
export default documentsService;
